export default __webpack_public_path__ + "static/media/thumbnail-hyper-mobile.40f3998a.png";